import { Popconfirm } from "antd";

const RemovePopconfirm = ({ title, description, handleDeleteClick }) => (
  <Popconfirm
    title={title}
    description={description}
    onConfirm={handleDeleteClick}
    okText="Yes"
    cancelText="No"
  >
    <img
      alt={`remove-attachment-icon`}
      src={`${process.env.PUBLIC_URL}/assets/images/icons/remove-trash.svg`}
      className="selected-file-icon"
    />
  </Popconfirm>
)

export default RemovePopconfirm;